import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuccess = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 412,
	height: 140,
	viewBox: "0 0 412 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 82.1255,
			y1: 60.7186,
			x2: 17.1255,
			y2: 75.7186,
			stroke: "#D9DEEB",
			strokeWidth: 1.09904
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 95.4286,
			y1: 63.8386,
			x2: 111.429,
			y2: 83.8386,
			stroke: "#D9DEEB",
			strokeWidth: 1.09904
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 122.771,
			y1: 86.6797,
			x2: 178.771,
			y2: 61.5694,
			stroke: "#D9DEEB",
			strokeWidth: 1.09904
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.99999 85.1809C13.4183 85.1809 17 81.5992 17 77.1809C17 72.7626 13.4183 69.1809 8.99999 69.1809C4.58171 69.1809 1 72.7626 1 77.1809C1 81.5992 4.58171 85.1809 8.99999 85.1809Z",
			stroke: "#D9DEEB",
			strokeWidth: 1.11125,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M8.9995 80.1807C10.6564 80.1807 11.9995 78.8375 11.9995 77.1807C11.9995 75.5238 10.6564 74.1807 8.9995 74.1807C7.34265 74.1807 5.99951 75.5238 5.99951 77.1807C5.99951 78.8375 7.34265 80.1807 8.9995 80.1807Z",
			fill: "#8CBCEF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M115.996 98.1809C120.414 98.1809 123.996 94.5992 123.996 90.1809C123.996 85.7626 120.414 82.1809 115.996 82.1809C111.577 82.1809 107.996 85.7626 107.996 90.1809C107.996 94.5992 111.577 98.1809 115.996 98.1809Z",
			stroke: "#D9DEEB",
			strokeWidth: 1.11125,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M115.995 93.1807C117.652 93.1807 118.995 91.8375 118.995 90.1807C118.995 88.5238 117.652 87.1807 115.995 87.1807C114.338 87.1807 112.995 88.5238 112.995 90.1807C112.995 91.8375 114.338 93.1807 115.995 93.1807Z",
			fill: "#8CBCEF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90.0015 66.1829C94.4197 66.1829 98.0015 62.6011 98.0015 58.1829C98.0015 53.7646 94.4197 50.1829 90.0015 50.1829C85.5832 50.1829 82.0015 53.7646 82.0015 58.1829C82.0015 62.6011 85.5832 66.1829 90.0015 66.1829Z",
			stroke: "#D9DEEB",
			strokeWidth: 1.11125,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M90.001 61.1826C91.6578 61.1826 93.001 59.8395 93.001 58.1826C93.001 56.5258 91.6578 55.1826 90.001 55.1826C88.3441 55.1826 87.001 56.5258 87.001 58.1826C87.001 59.8395 88.3441 61.1826 90.001 61.1826Z",
			fill: "#8CBCEF"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 284.651,
			y1: 29.0928,
			x2: 225.219,
			y2: 53.9825,
			stroke: "#D9DEEB",
			strokeWidth: 1.09904
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 339.941,
			y1: 94.0411,
			x2: 394.941,
			y2: 87.0411,
			stroke: "#D9DEEB",
			strokeWidth: 1.09904
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 297.485,
			y1: 31.3203,
			x2: 328.485,
			y2: 87.3203,
			stroke: "#D9DEEB",
			strokeWidth: 1.09904
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332.005 102.587C336.423 102.587 340.005 99.005 340.005 94.5867C340.005 90.1684 336.423 86.5867 332.005 86.5867C327.587 86.5867 324.005 90.1684 324.005 94.5867C324.005 99.005 327.587 102.587 332.005 102.587Z",
			stroke: "#D9DEEB",
			strokeWidth: 1.09904,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332.005 97.5864C333.661 97.5864 335.005 96.2433 335.005 94.5864C335.005 92.9296 333.661 91.5864 332.005 91.5864C330.348 91.5864 329.005 92.9296 329.005 94.5864C329.005 96.2433 330.348 97.5864 332.005 97.5864Z",
			fill: "#8CBCEF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403.012 94.5859C407.43 94.5859 411.012 91.0042 411.012 86.5859C411.012 82.1677 407.43 78.5859 403.012 78.5859C398.593 78.5859 395.012 82.1677 395.012 86.5859C395.012 91.0042 398.593 94.5859 403.012 94.5859Z",
			stroke: "#D9DEEB",
			strokeWidth: 1.09904,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403.011 89.5857C404.668 89.5857 406.011 88.2425 406.011 86.5857C406.011 84.9288 404.668 83.5857 403.011 83.5857C401.355 83.5857 400.011 84.9288 400.011 86.5857C400.011 88.2425 401.355 89.5857 403.011 89.5857Z",
			fill: "#8CBCEF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M292.01 33.585C296.428 33.585 300.01 30.0032 300.01 25.585C300.01 21.1667 296.428 17.585 292.01 17.585C287.592 17.585 284.01 21.1667 284.01 25.585C284.01 30.0032 287.592 33.585 292.01 33.585Z",
			stroke: "#D9DEEB",
			strokeWidth: 1.09904,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M292.01 28.5847C293.667 28.5847 295.01 27.2416 295.01 25.5847C295.01 23.9279 293.667 22.5847 292.01 22.5847C290.353 22.5847 289.01 23.9279 289.01 25.5847C289.01 27.2416 290.353 28.5847 292.01 28.5847Z",
			fill: "#8CBCEF"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M55.3033 104.667C55.3033 106.687 53.6733 108.317 51.6533 108.317C49.6333 108.317 48.0034 106.687 48.0034 104.667C48.0034 102.647 49.6333 101.017 51.6533 101.017C53.6733 101.017 55.3033 102.647 55.3033 104.667Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M370.657 43.8052C370.657 45.8252 369.027 47.4553 367.007 47.4553C364.987 47.4553 363.357 45.8252 363.357 43.8052C363.357 41.7852 364.987 40.1553 367.007 40.1553C369.027 40.1553 370.657 41.7852 370.657 43.8052Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.652 11.3289C33.3887 11.3163 33.1254 11.3789 32.8872 11.5419C32.3229 11.9306 32.1725 12.6956 32.5612 13.2598L39.7832 23.842C39.9963 24.1554 40.3474 24.3561 40.7236 24.3812C41.0746 24.4188 41.4758 24.2557 41.7266 23.9799L46.3908 18.8518L54.7538 32.6941C54.9544 33.02 55.2804 33.2332 55.6566 33.2833C56.0327 33.3209 56.4089 33.1955 56.6847 32.9322L61.7627 27.8793L63.0634 26.5912C63.2243 26.2673 63.1794 25.5597 62.9788 25.2588C62.7782 24.9579 62.4397 24.7572 62.0761 24.7196C61.6874 24.6695 61.3489 24.8199 61.0856 25.0707L56.0703 30.0609L47.6697 16.1435C47.4691 15.805 47.118 15.5918 46.7293 15.5542C46.3156 15.5041 45.9519 15.667 45.6886 15.9554L40.9618 21.1462L34.6299 11.8554C34.4042 11.5294 34.0407 11.3414 33.6771 11.3163L33.652 11.3289Z",
			fill: "#40C676"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M318.888 114.145C319.151 114.132 319.414 114.195 319.652 114.358C320.217 114.746 320.367 115.511 319.978 116.075L312.756 126.658C312.543 126.971 312.192 127.172 311.816 127.197C311.465 127.234 311.064 127.071 310.813 126.796L306.149 121.667L297.786 135.51C297.585 135.836 297.259 136.049 296.883 136.099C296.507 136.137 296.131 136.011 295.855 135.748L290.777 130.695L289.476 129.407C289.315 129.083 289.36 128.375 289.561 128.074C289.761 127.774 290.1 127.573 290.463 127.535C290.852 127.485 291.191 127.636 291.454 127.886L296.469 132.877L304.87 118.959C305.07 118.621 305.422 118.408 305.81 118.37C306.224 118.32 306.588 118.483 306.851 118.771L311.578 123.962L317.91 114.671C318.135 114.345 318.499 114.157 318.862 114.132L318.888 114.145Z",
			fill: "#40C676"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 148.95,
			y: 8.80859,
			width: 114.098,
			height: 114.098,
			rx: 30.0338,
			fill: "#C9EACB"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M151.283 103.033C152.344 106.716 153.882 109.737 156.11 112.348C157.136 113.551 158.256 114.671 159.459 115.697C167.882 122.885 180.578 122.885 205.971 122.885C231.363 122.885 244.059 122.885 252.482 115.697C253.685 114.671 254.805 113.551 255.831 112.348C263.019 103.925 263.019 91.2288 263.019 65.8366C263.019 40.4443 263.019 27.7482 255.831 19.3251C255.401 18.821 254.954 18.3314 254.492 17.8572C256.854 26.0557 256.854 37.5319 256.854 55.0532C256.854 80.4454 256.854 93.1416 249.666 101.565C248.639 102.767 247.519 103.887 246.316 104.914C237.893 112.102 225.197 112.102 199.805 112.102C174.413 112.102 161.716 112.102 153.293 104.914C152.595 104.318 151.924 103.69 151.283 103.033Z",
			fill: "#4FBA55"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M227.66 49.0916L197.972 78.7799L183.127 63.9357",
			stroke: "#328B36",
			strokeWidth: 3.74579,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgSuccess);
export default ForwardRef;
